// extracted by mini-css-extract-plugin
module.exports = {"update-card":"o+APqrdPqtrJ0Uzzx4lDXQ==","update-card-title":"_4jwoAyhf3XrxQ5XkS1y2Bg==","update-card-desc":"BPHS+56++fLpIomat+C00w=="};